// Submit Client for creating service requests
// Handles POST to /create_service_request endpoint

import { API_BASE_URL } from './apiConfig';
import { ServiceRequestPayload } from '../../types/ServiceRequest';

/**
 * Submit a service request to the Xano backend
 * @param payload - Complete service request data
 * @returns API response
 */
export async function submitServiceRequest(payload: ServiceRequestPayload): Promise<any> {
    const response = await fetch(`${API_BASE_URL}/create_service_request`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        throw new Error(`Submission failed: ${response.statusText}`);
    }

    return response.json();
}
